function initSizeWarningModal() {
    const sizeWarningModal = document.getElementById('SizeWarning');
    const ATCButton = sizeWarningModal?.querySelector('button[type=submit]');

    if (!sizeWarningModal || !ATCButton) return;

    // Check if already initialized to prevent duplicate listeners
    if (ATCButton.dataset.sizeWarningInitialized) return;
    ATCButton.dataset.sizeWarningInitialized = 'true';

    let sizeWarningSubscriber = null;

    const closeModal = () => {
        sizeWarningModal.hide();
        // Clean up subscription after use
        if (sizeWarningSubscriber) {
            sizeWarningSubscriber();
            sizeWarningSubscriber = null;
        }
    };

    ATCButton.addEventListener('click', () => {
        // Prevent multiple subscriptions
        if (sizeWarningSubscriber) {
            sizeWarningSubscriber();
        }

        sizeWarningSubscriber = theme.pubsub.subscribe(
            theme.pubsub.PUB_SUB_EVENTS.cartUpdate,
            (event) => {
                console.log('debug cart update event:', event);
                console.log('debug event source:', event.source);
                // Only close modal for product form cart updates
                if (event.source === 'product-form') {
                    console.log('debug: closing modal because source is product-form');
                    closeModal();
                } else {
                    console.log('debug: NOT closing modal, source is:', event.source);
                }
            }
        );
    });
}

// Initialize on page load (for regular product pages)
document.addEventListener('DOMContentLoaded', initSizeWarningModal);

// Initialize when quick-view content is loaded (for collection pages)
document.addEventListener('modal:afterShow', initSizeWarningModal);